import type {Editor} from 'grapesjs';
import {isUserLoggedIn} from '@Libraries/user.library';
import {closeEmbeddedEditor, closeEmbeddedEditorWithoutCallback, EmbeddedEditorMessageType} from '@Libraries/embedded-editor';
import type {EmbeddedEditorElementsToHide} from '@Libraries/embedded-editor';
import {authenticateUser} from '@EmailMakerReact/lib/email-maker-publish-library';
import {getCurrentIdEmailTemplate, saveEmailTemplateToCache} from '@EmailMakerReact/lib/email-maker-storage-library';
import {logEmailMakerError} from '@EmailMakerReact/lib/email-maker-error-library';
import type {EmailMakerImmutableStore} from '@EmailMakerReact/email-maker-react.types';

export function closeEmbeddedEmailEditor(isSilentClose: boolean): void {
  if (isSilentClose) {
    closeEmbeddedEditorWithoutCallback();
  } else {
    closeEmbeddedEditor();
  }
}

export async function saveAndCloseEmbeddedEditor(editor: Editor): Promise<void> {
  if (!isUserLoggedIn()) {
    authenticateUser(editor, {
      cb: (): void => {
        void saveAndCloseEmbeddedEditor(editor);
      },
    });
    return;
  }

  try {
    await saveEmailTemplateToCache(editor);
  } catch (e: unknown) {
    logEmailMakerError('saveAndCloseEmbeddedEditor: save failed before close', e);
  }

  postSaveMessageToParent(editor);
  closeEmbeddedEmailEditor(true);
}

// Target origin unknown here; '*' is intentional.
function postSaveMessageToParent(editor: Editor): void {
  window.parent.postMessage(`${EmbeddedEditorMessageType.SAVE}~${getCurrentIdEmailTemplate(editor)}`, '*');
}

export function isEmbedElementHidden(store: EmailMakerImmutableStore, element: EmbeddedEditorElementsToHide): boolean {
  return store.elementsToHide.includes(element);
}
